var map = {
	"./404.jpg": "2e60",
	"./banner/DYOT-banner-tag1-agnostic.gif": "9b7d",
	"./banner/DYOT-banner-tag1-licensing.gif": "3029",
	"./banner/DYOT-banner-tag2.gif": "96c0",
	"./banner/DYOT-banner-tag3-agnostic.gif": "6632",
	"./banner/DYOT-banner-tag3-licensing.gif": "532b",
	"./banner/DYOT-banner-tag4.gif": "1f1f",
	"./banner/DYOT-banner-tag5.gif": "a331",
	"./collar-placeholder.svg": "0592",
	"./collars/buckle_500x500.svg": "1b09",
	"./dyot/QRCodePlaceholder.svg": "6feb",
	"./dyot/SilverTagBase.svg": "a7f5",
	"./dyot/TagPersonalization.svg": "7044",
	"./essentials-placeholder.svg": "afec",
	"./glow-tag.jpg": "bce9",
	"./icon_handheart.png": "4ef3",
	"./icon_handheart@2x.png": "3ce6",
	"./icon_handheart@3x.png": "01aa",
	"./leash-placeholder.svg": "2768",
	"./marketing/shop-tags-personalize-qr.png": "ca8e",
	"./paw_print.png": "26d9",
	"./product-tag-hrt-thumbnail.png": "92d0",
	"./tag-placeholder.svg": "bd0e",
	"./tag_icon_grey.png": "0137",
	"./tag_size_large.svg": "f1e0",
	"./tag_size_small.svg": "f6b8",
	"./wallets/optInImage-ca.png": "a6d7",
	"./wallets/optInImage-us.png": "f7cc",
	"./wallets/paw_card.png": "07e5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";